import * as React from 'react';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import Collapse from '@mui/material/Collapse';
import IconButton from '@mui/material/IconButton';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import Tooltip from '@mui/material/Tooltip';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import Visibility from '@mui/icons-material/Visibility';
import DeleteIcon from '@mui/icons-material/Delete';
import { makeStyles } from '@material-ui/core/styles';
import MDBox from 'components/MDBox';
import { TableSortLabel, InputAdornment, MenuItem, Select, TextField, Badge, TableFooter } from '@mui/material';
import { useState } from 'react';
import crudsService from 'services/cruds-service';
import TablePagination from '@mui/material/TablePagination';
import moment from 'moment/moment';
import { TablePaginationActions } from '../CustomPaginationTable';

const getRows = (info) => {
  let updatedInfo = info.map((row) => {
    const createdAt = row.attributes.created_at
      ? moment(row.attributes.created_at).format('MMMM DD, YYYY h:mm:ss A')
      : ''
    const updatedAt = row.attributes.updated_at
      ? moment(row.attributes.updated_at).format('MMMM DD, YYYY h:mm:ss A')
      : ''
    const subType = row.attributes.is_parent
      ? 'Alert Created'
      : row.attributes.is_healed
        ? 'Alert Healed'
        : 'Alert Resent'
    const statusText =
      row.attributes?.StatusOption?.StatusType?.status_name || ''
    return {
      id: row.id,
      device_id: row.attributes.device_id,
      alert_type: row.attributes.AlertType?.type_name,
      alert_type_id: row.attributes.alert_type_id,
      alert_type_category: row.attributes?.AlertType?.category,
      device: row.attributes.Device?.name,
      sub_type: subType,
      is_parent: row.attributes.is_parent,
      created_at: createdAt,
      updated_at: updatedAt,
      status: (
        <Badge
          color={
            row.attributes?.StatusOption?.BadgeDetail?.color || 'primary'
          }
          variant={row.attributes?.StatusOption?.BadgeDetail?.variant}
          badgeContent={row.attributes?.StatusOption?.StatusType?.status_name}
          style={{ marginLeft: '30px' }}
        ></Badge>
      ),
      statusText: statusText,
    }
  })
  return updatedInfo
}

// Create a row function
const Row = ({ group, columns, clickViewHandler, clickDeleteHandler }) => {
  const [open, setOpen] = React.useState(false);
  const [subData, setSubtData] = React.useState([])

  async function openCollapse(value) {
    setOpen(value)
    if (value) {
      // setLoader(true)
      try {
        let resp = await crudsService.getSubAlerts(group.id)
        if (resp?.success) {
          const rowData = getRows(resp.data)
          setSubtData(rowData)
        }
      } catch (error) {
        console.error('openCollapse', error)
      }
      // setLoader(false)
    }
  }

  return (
    <>
      <TableRow>
        <TableCell>
          <IconButton aria-label="expand row" size="small" onClick={() => openCollapse(!open)}>
            {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </IconButton>
        </TableCell>
        {columns.map((column) => (
          <TableCell key={column.accessor} width={column.width} style={{ fontSize: '0.875rem', fontWeight: '400' }}>
            {column.accessor === 'actions' ? (
              <Box display="flex" alignItems="center">
                <Tooltip title="View Info">
                  <IconButton onClick={() => clickViewHandler(group.id)}>
                    <Visibility />
                  </IconButton>
                </Tooltip>
                {
                  clickDeleteHandler &&
                  <Tooltip title="Delete Alert">
                    <IconButton onClick={(e) => clickDeleteHandler(e, group.id)}>
                      <DeleteIcon />
                    </IconButton>
                  </Tooltip>
                }
              </Box>
            ) : (
              group[column.accessor]
            )}
          </TableCell>
        ))}
      </TableRow>
      <TableRow sx={{ paddingTop: '0px !important', paddingBottom: '0px !important' }}>
        <TableCell colSpan={columns.length + 1} sx={{ paddingTop: '0px !important', paddingBottom: '0px !important' }} style={{ paddingLeft: '43px', paddingTop: '0px !important', paddingBottom: '0px !important', fontSize: '0.875rem' }} >
          <Collapse in={open} timeout="auto" unmountOnExit>
            {subData.map((child, i) => (
              <TableRow key={child.id + i}>
                {columns.map((column) => (
                  <TableCell key={column.accessor} width={column.width} sx={{ paddingTop: '0px !important', paddingBottom: '0px !important' }}>
                    {['id', 'status', 'sub_type', 'created_at', 'updated_at', 'actions'].includes(column.accessor) ? (
                      column.accessor === 'actions' ? (
                        <Box display="flex" alignItems="center">
                          <Tooltip title="View Info">
                            <IconButton onClick={() => clickViewHandler(group.id)}>
                              <Visibility />
                            </IconButton>
                          </Tooltip>
                        </Box>
                      ) : (
                        <TableCell key={column.accessor} style={{ fontSize: '0.875rem' }}>{child[column.accessor]}</TableCell>
                      )
                    ) : null}
                  </TableCell>
                ))}

              </TableRow>
            ))}
          </Collapse>
        </TableCell>
      </TableRow>
    </>
  );
};


Row.propTypes = {
  parentRow: PropTypes.shape({
    id: PropTypes.string.isRequired,
    alert_type: PropTypes.string,
    device: PropTypes.string,
    created_at: PropTypes.string,
    updated_at: PropTypes.string,
    status: PropTypes.node.isRequired,
  }).isRequired,
  childRows: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      alert_type: PropTypes.string,
      device: PropTypes.string,
      created_at: PropTypes.string,
      updated_at: PropTypes.string,
      status: PropTypes.node.isRequired,
    })
  ).isRequired,
  columns: PropTypes.array.isRequired,
  clickViewHandler: PropTypes.func.isRequired,
  clickDeleteHandler: PropTypes.func.isRequired,
};

const useStyles = makeStyles({
  customTableHead: {
    display: 'table-header-group!important', // Use the correct CSS property without quotes
  },
});

export default function CollapsibleTable({ data, columns, clickViewHandler, clickDeleteHandler, page, setPage, rowsPerPage, setRowsPerPage, count }) {
  const classes = useStyles();
  // const [searchQuery, setSearchQuery] = React.useState('');
  const [order, setOrder] = useState('desc');
  const [orderBy, setOrderBy] = useState('');

  const groupAlerts = (alerts) => {
    return alerts;
    const alertsByDevice = alerts.reduce((acc, alert) => {
      if (!acc[alert.device_id]) {
        acc[alert.device_id] = [];
      }
      acc[alert.device_id].push(alert);
      return acc;
    }, {});

    const allGroupedAlerts = Object.values(alertsByDevice).flatMap(deviceAlerts => {
      const groupedAlerts = [];
      const groupsByType = {};

      deviceAlerts.forEach((alert) => {
        if (alert.is_parent) {
          // Start a new group for the current alert type
          if (!groupsByType[alert.alert_type_id]) {
            groupsByType[alert.alert_type_id] = {
              device_id: alert.device_id,
              alert_type_id: alert.alert_type_id,
              header: alert,
              children: [],
            };
          } else {
            // If there's an existing group for the alert type, push it to groupedAlerts
            groupedAlerts.push(groupsByType[alert.alert_type_id]);
            // Start a new group
            groupsByType[alert.alert_type_id] = {
              device_id: alert.device_id,
              alert_type_id: alert.alert_type_id,
              header: alert,
              children: [],
            };
          }
        } else if (groupsByType[alert.alert_type_id]) {
          // Add to the existing group for the alert type
          groupsByType[alert.alert_type_id].children.push(alert);
        }
      });

      // Add remaining groups to the groupedAlerts array
      Object.values(groupsByType).forEach(group => groupedAlerts.push(group));

      return groupedAlerts;
    });

    return allGroupedAlerts;
  };

  const groupedData = groupAlerts(data);

  const handleSort = (column) => {
    const isAsc = orderBy === column && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(column);
  };

  const VerticalSortIcon = () => (
    <Box sx={{ display: 'flex', flexDirection: 'column', flexDirection: 'column', alignItems: 'center' }}>
      <KeyboardArrowUpIcon />
      <KeyboardArrowDownIcon />
    </Box>
  );

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  async function onRowsPerPageChange(e, value) {
    e.stopPropagation();
    setRowsPerPage(value)
  }

  return (
    <TableContainer component={Paper}>
      {/* <MDBox style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '16px' }}>
        <MDBox></MDBox>
        <TextField
          value={searchQuery}
          onChange={handleSearchChange}
          placeholder="Search"
        />
      </MDBox> */}
      <Table aria-label="collapsible table">
        <TableHead classes={{ root: classes.customTableHead }}>
          <TableRow>
            <TableCell />
            {columns
              .filter((column) => column.show !== false)
              .map((column) => (
                <TableCell
                  key={column.accessor}
                  sx={{
                    textTransform: 'uppercase',
                    cursor: 'pointer',
                    userSelect: 'none',
                    fontSize: '0.65rem',
                    opacity: '0.7',
                    justifyContent: 'space-between',
                    marginLeft: 0,
                  }}
                  sortDirection={orderBy === column.accessor ? order : false}
                >
                  {column.Header}
                  {
                    column.Header !== 'actions' &&
                    <TableSortLabel
                      IconComponent={VerticalSortIcon}
                      active={orderBy === column.accessor}
                      direction={orderBy === column.accessor ? order : 'asc'}
                      onClick={() => handleSort(column.accessor)}
                    >
                    </TableSortLabel>
                  }
                </TableCell>
              ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {groupedData
            // .filter(group => Object.values(group).some(value => String(value).toLowerCase().includes(searchQuery?.toLowerCase() ?? '')))
            .sort((a, b) => {
              const compareField = 'id';
              if (a[compareField] < b[compareField]) return order === 'asc' ? -1 : 1;
              if (a[compareField] > b[compareField]) return order === 'asc' ? 1 : -1;
              return 0;
              // if (orderBy) {
              //   if (a.header[orderBy] < b.header[orderBy]) return order === 'asc' ? -1 : 1;
              //   if (a.header[orderBy] > b.header[orderBy]) return order === 'asc' ? 1 : -1;
              //   return 0;
              // }
              // return 0;
            })
            .map((group) => (
              <Row
                key={group.id}
                group={group}
                columns={columns.filter((column) => column.show !== false)}
                clickViewHandler={clickViewHandler}
                clickDeleteHandler={clickDeleteHandler}
              />
            ))}
        </TableBody>
      </Table>
      {
        count > rowsPerPage ?
          <TablePaginationActions count={count} page={page} rowsPerPage={rowsPerPage} onPageChange={handleChangePage} onRowsPerPageChange={onRowsPerPageChange} /> : ''
      }
    </TableContainer>
  );
}


CollapsibleTable.propTypes = {
  data: PropTypes.array.isRequired,
  columns: PropTypes.array.isRequired,
  clickViewHandler: PropTypes.func.isRequired,
  clickDeleteHandler: PropTypes.func.isRequired,
};
